import { errorWrapper } from 'utility/error';

import { apiClient } from './api';

// Sends a delete-action request to Action_Delete. The endpoint returns no
// payload — we only care whether it succeeded.
async function deleteAction(args: { tenantId: string; actionId: string }) {
  const { tenantId, actionId } = args;

  // Action_Delete returns ApiResult (no data field); pad the shape so it
  // matches what errorWrapper expects.
  const apiCall = apiClient
    .Action_Delete(undefined, { params: { tenantId, actionId } })
    .then((res) => ({ ...res, data: undefined }));

  return await errorWrapper({
    apiCall,
    error: {
      message: '',
      severity: 'warning',
      title: 'Failed to delete action',
    },
    onSuccess: () => undefined,
  });
}

export { deleteAction };
